// removed by extract-text-webpack-plugin
module.exports = {"component":"_1elQsfkP54HbJFfB0XKP5w"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContentPanel/ContentPanel.css
// module id = 1265
// module chunks = 0